import { ApiClient } from '@/services/http/apiClient';
import type { ApiResponse, Offer, Pagination } from '@/types/api';

export const OfferService = {
  // Admin
  async list(params?: {
    page?: number;
    per_page?: number;
    product_id?: number;
    active_only?: boolean;
    sort_by?: string;
    sort_order?: 'asc' | 'desc';
  }): Promise<Pagination<Offer>> {
    const response = await ApiClient.get<ApiResponse<Pagination<Offer>>>('/admin/offers', { query: params });
    if (!response.success) {
      throw new Error(response.message || 'Erro ao listar ofertas');
    }
    return response.data;
  },
  async show(id: number): Promise<Offer> {
    const response = await ApiClient.get<ApiResponse<Offer>>(`/admin/offers/${id}`);
    if (!response.success) {
      throw new Error(response.message || 'Erro ao buscar oferta');
    }
    return response.data;
  },
  async create(data: { product_id: number; discount_percent: number; starts_at?: string | null; ends_at?: string | null }): Promise<Offer> {
    const response = await ApiClient.post<ApiResponse<Offer>>('/admin/offers', { body: data });
    if (!response.success) {
      throw new Error(response.message || 'Erro ao criar oferta');
    }
    return response.data;
  },
  async update(id: number, data: Partial<Offer>): Promise<Offer> {
    const response = await ApiClient.put<ApiResponse<Offer>>(`/admin/offers/${id}`, { body: data });
    if (!response.success) {
      throw new Error(response.message || 'Erro ao atualizar oferta');
    }
    return response.data;
  },
  async delete(id: number): Promise<{ success: boolean; message?: string }> {
    return ApiClient.delete<{ success: boolean; message?: string }>(`/admin/offers/${id}`);
  },
  async toggleActive(id: number): Promise<Offer> {
    const response = await ApiClient.patch<ApiResponse<Offer>>(`/admin/offers/${id}/toggle-active`);
    if (!response.success) {
      throw new Error(response.message || 'Erro ao alterar status da oferta');
    }
    return response.data;
  },
};